import {dashboardChartColors} from '../../../../../../util/uiconstants';
import {labels as utilLabels} from '../../../../../../util/utils';

import {config as barchartColumnConfig} from '../../common/BarchartColumn';

export const prop = 'status';

export const config = (labels) =>
	barchartColumnConfig({
		id: 'milestonesStatus',
		label: labels.status,
		prop,
		getSeries: (item) => [
			{
				name: utilLabels.completeUpperCase,
				data: [item.tC],
				color: dashboardChartColors.green[3]
			},
			{
				name: utilLabels.inReview,
				data: [item.tIR],
				color: dashboardChartColors.green[2]
			},
			{
				name: utilLabels.inProgress,
				data: [item.tIP],
				color: dashboardChartColors.green[1]
			},
			{
				name: utilLabels.open,
				data: [item.tO],
				color: dashboardChartColors.green[0]
			}
		]
	});
